import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { ShareCompanyProfileResponseDto } from '@wilson/interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShareCompanyProfileGateway {
  protected readonly http = inject(HttpClient);
  protected readonly config = inject<ConfigOptions>(ConfigService);
  protected readonly path = 'company-profile';

  getShareCompanyProfile(
    id: string,
  ): Observable<ShareCompanyProfileResponseDto | null> {
    return this.http.get<ShareCompanyProfileResponseDto | null>(
      `${this.config.host}/${this.path}/${id}`,
    );
  }

  putShareCompanyProfile(
    formData: FormData,
  ): Observable<ShareCompanyProfileResponseDto> {
    return this.http.put<ShareCompanyProfileResponseDto>(
      `${this.config.host}/${this.path}`,
      formData,
    );
  }
}
